@if (dataPoints().length > 0) {
  <div
    class="ts-data-table"
    role="grid"
    aria-label="Timeseries data"
    tabindex="0"
    (keydown)="onGridKeydown($event)"
  >
    <div role="row" class="ts-data-table__header-row">
      <div
        role="columnheader"
        class="ts-data-table__cell ts-data-table__cell--header"
      >
        Timestamp
      </div>
      <div
        role="columnheader"
        class="ts-data-table__cell ts-data-table__cell--header"
      >
        Value
      </div>
    </div>
    @for (point of dataPoints(); track point.timestamp; let i = $index) {
      <div
        role="row"
        class="ts-data-table__row"
        [class.ts-data-table__row--focused]="focusedRow() === i"
        (click)="focusRow(i)"
      >
        <div role="gridcell" class="ts-data-table__cell">
          {{ formatTimestamp(point.timestamp) }}
        </div>
        <div
          role="gridcell"
          class="ts-data-table__cell ts-data-table__cell--value"
        >
          {{ formatValue(point.value) }}
        </div>
      </div>
    }
  </div>
  <div class="ts-data-table__footer">
    <span class="ts-data-table__count"
      >{{ dataPoints().length }} data points</span
    >
  </div>
} @else {
  <div class="ts-data-table__empty">
    <p>No data available</p>
  </div>
}
